<template>
    <div class="sahre-post share-social">
        <div class="title">
            <h4 v-if="lang != 'kz/'">{{shareArr[0].title}}</h4>
            <h4 v-else>Бөлісу:</h4>
            <!-- {{shareArr[0].data_title}}
            {{shareArr[0].data_link}} -->
        </div>
        <div class="social-share-btns">
            <!-- <button class="button btn-share-to-social"><svg-icon icon-class="mail" className="share-icon icon-mail"/></button> -->
            <button class="button btn-share-to-social btn-share-to-social-desctop" data-sharer="whatsapp" :data-title="shareArr[0].data_title" :data-url="shareArr[0].data_link" data-web><svg-icon icon-class="whatsapp" className="share-icon icon-whatsapp"/></button>
            <button class="button btn-share-to-social btn-share-to-social-mobile" data-sharer="whatsapp" :data-title="shareArr[0].data_title" :data-url="shareArr[0].data_link"><svg-icon icon-class="whatsapp" className="share-icon icon-whatsapp"/></button>
            <button class="button btn-share-to-social" data-sharer="telegram" :data-title="shareArr[0].data_title" :data-url="shareArr[0].data_link"><svg-icon icon-class="telegram" className="share-icon icon-telegram"/></button>
            <button class="button btn-share-to-social" data-sharer="facebook" data-hashtag="BAZIS_A_ENJOY_LIFE" :data-quote="shareArr[0].data_title" :data-url="shareArr[0].data_link"><svg-icon icon-class="facebook" className="share-icon icon-facebook"/></button>
            <!-- <button class="button btn-share-to-social" data-sharer="vk" :data-title="shareArr[0].data_title" :data-url="shareArr[0].data_link" v-if="projectHost != 'kohota'"><svg-icon icon-class="vk" className="share-icon icon-vk"/></button> -->
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'share-post',
        props: ['shareArr'],
        components: {
        },
        data () {
            return {
                projectHost: window.host,
                lang: window.GlobalLang,
            }
        },
        computed: mapGetters({
        }),
        methods: {
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
            window.Sharer.init();
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/share/share-post.scss';
    @import '@/styles/respond/share/share-respond.scss';
</style>